module.exports = __webpack_public_path__ + "static/media/banner.3e33d75e.png";